import {
    getThemeIdFromParameter,
    getIsDarkThemeFromParameter,
} from '../utils/optionalArgumentHelpers';

export function getThemeDataMapKey(themeId: string, isDarkTheme: boolean): string {
    const effectiveThemeId = getThemeIdFromParameter(themeId);
    const effectiveIsDarkTheme = getIsDarkThemeFromParameter(isDarkTheme);
    return `${effectiveThemeId}${effectiveIsDarkTheme ? '.dark' : ''}`;
}
